import { render } from "./EventCard.vue?vue&type=template&id=2218f62c&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"

import "./EventCard.vue?vue&type=style&index=0&id=2218f62c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2218f62c"

export default script